import React from 'react';
import { Link } from 'react-router-dom';
import { MessageSquare } from 'lucide-react';
import PublicFooter from '../components/PublicFooter';

const Deauthorize = () => {
  return (
    <div className="min-h-screen bg-white flex flex-col">
      {/* Header */}
      <header className="border-b">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
          <Link to="/" className="flex items-center space-x-2">
            <MessageSquare className="h-8 w-8 text-blue-600" />
            <span className="text-2xl font-bold text-gray-900">ChatFlow</span>
          </Link>
        </div>
      </header>

      {/* Content */}
      <main className="flex-1 py-12">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <h1 className="text-4xl font-bold text-gray-900 mb-8">Deauthorization — ChatFlow</h1>

          <div className="prose prose-gray max-w-none">
            <p className="text-lg text-gray-700 mb-6">
              When a user removes or disconnects ChatFlow from their Instagram account, access tokens are immediately invalidated and the app no longer has access to the user's data.
            </p>

            <p className="text-lg text-gray-700 mb-6">
              Any data previously processed is handled according to our{' '}
              <Link to="/privacy" className="text-blue-600 hover:underline">Privacy Policy</Link>
              {' '}and{' '}
              <Link to="/data-deletion" className="text-blue-600 hover:underline">Data Deletion Policy</Link>.
            </p>

            <p className="text-lg text-gray-700 mb-6">
              If you have any questions regarding deauthorization, please contact us at{' '}
              <a href="mailto:contact@chatflow.info" className="text-blue-600 hover:underline">
                contact@chatflow.info
              </a>.
            </p>
          </div>
        </div>
      </main>

      <PublicFooter />
    </div>
  );
};

export default Deauthorize;
